import { IconPresentationProps } from "@insite/mobius/Icon";
import * as React from "react";

const Video: React.FC<IconPresentationProps> = props => {
    return (
        <svg
            focusable="false"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            fillRule="nonzero"
            stroke="none"
            role="img"
        >
            {props.title && <title>{props.title}</title>}
            <path d="M 0 0 L 0 24 L 24 24 L 24 0 L 0 0 z M 5.7382812 6.3808594 L 13.390625 6.3808594 C 14.563935 6.3808594 15.533203 7.3481745 15.533203 8.5214844 L 15.533203 10.994141 L 20.402344 6.9160156 L 20.402344 17.083984 L 15.533203 13.005859 L 15.533203 15.478516 C 15.533203 16.651826 14.563935 17.619141 13.390625 17.619141 L 5.7382812 17.619141 C 4.5649714 17.619141 3.5976564 16.651826 3.5976562 15.478516 L 3.5976562 8.5214844 C 3.5976563 7.3481747 4.5649716 6.3808594 5.7382812 6.3808594 z M 5.7382812 7.8808594 C 5.3700257 7.8808594 5.0976562 8.1532289 5.0976562 8.5214844 L 5.0976562 15.478516 C 5.0976563 15.846772 5.3700259 16.119141 5.7382812 16.119141 L 13.390625 16.119141 C 13.758881 16.119141 14.033203 15.846772 14.033203 15.478516 L 14.033203 12 L 14.033203 8.5214844 C 14.033203 8.153229 13.758881 7.8808594 13.390625 7.8808594 L 5.7382812 7.8808594 z M 18.902344 10.128906 L 16.667969 12 L 18.902344 13.871094 L 18.902344 10.128906 z " />
        </svg>
    );
};

export default React.memo(Video);
